<script lang="ts">
    import { Col ,ListGroup, ListGroupItem} from "sveltestrap";
    import {  Customcontent, Donecidelit, Donecidelitnonmiporta, href, Listgroupitemheading } from "../../../utils/Constant/Constant";
    import Card from "../UiCommenCard.svelte";
</script>
<Col sm="12" xl="12">
    <Card cardHeaderprops="pb-0" headerTitle={Customcontent}>
      <div slot="contentbody">
            <ListGroup>
                <ListGroupItem class="list-group-item-action flex-column align-items-start active" href={href}>
                    <div class="d-flex w-100 justify-content-between">
                        <h5 class="mb-1">{Listgroupitemheading}</h5>
                        <small>3 days ago</small>
                    </div>
                    <p class="mb-1">{Donecidelit}</p>
                    <small>{Donecidelitnonmiporta}</small>
                </ListGroupItem>
                <ListGroupItem class="list-group-item-action flex-column align-items-start" href={href}>
                    <div class="d-flex w-100 justify-content-between">
                        <h5 class="mb-1">{Listgroupitemheading}</h5><small class="text-muted">3 days ago</small>
                    </div>
                    <p class="mb-1">{Donecidelit}</p>
                    <small class="text-muted">{Donecidelitnonmiporta}</small>
                </ListGroupItem>
                <ListGroupItem class="list-group-item-action flex-column align-items-start" href={href}>
                    <div class="d-flex w-100 justify-content-between">
                        <h5 class="mb-1">{Listgroupitemheading}</h5><small class="text-muted">3 days ago</small>
                    </div>
                    <p class="mb-1">{Donecidelit}</p>
                    <small class="text-muted">{Donecidelitnonmiporta}</small>
                </ListGroupItem>
            </ListGroup>
        </div>
    </Card>
</Col>